import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import type { Observation } from "@/types/database/observations";
import { createGetDiaryKey } from "../../diaries/api";

export async function updateObservation(observation: Observation["Update"]) {
	if (!observation.observation_id) {
		throw new Error("Observation ID is required for update");
	}

	const { data, error } = await supabaseClient
		.from("observations")
		.update(observation)
		.eq("observation_id", observation.observation_id)
		.select("*, diaries(patient_id)")
		.single();
	if (error) throw error;
	return data;
}

interface ObservationMutation {
	diaryId: string;
}
export const useObservationMutation = ({ diaryId }: ObservationMutation) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: ["observation"],
		mutationFn: (observation: Observation["Update"]) => {
			return updateObservation(observation);
		},
		onError: () => {
			toast.error("Error updating observation");
		},
		onSuccess: () => {
			toast.success("Observation updated");
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: createGetDiaryKey(diaryId) });
		},
	});
};
